import React, { useRef, useState, useMemo, useEffect } from "react";
import { Form, Button, Card, Alert, Image } from "react-bootstrap";
import { useAuth } from "contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import { db } from "../firebase/config";
import {
  collection,
  query,
  where,
  onSnapshot,
  setDoc,
  addDoc,
  doc,
} from "firebase/firestore";
import { imageToThumb } from "utils/image";

const UpdateProfile = () => {
  const emailRef = useRef();
  const pwdRef = useRef();
  const nameRef = useRef();
  const pwdConfirmRef = useRef();
  const { currentUser, changeEmail, changePassword } = useAuth();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const history = useHistory();
  const inputImage = useRef();

  const [adminRecord, setAdminRecord] = useState();

  let onImageSelect = (event) => {
    console.log(event);
    if (event.target.files[0]) {
      imageToThumb(event.target.files[0], 100).then((i) => {
        setImage(i);
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pwdRef.current.value !== pwdConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    const promises = [];
    setLoading(true);
    setError("");
    if (emailRef.current.value !== currentUser.email) {
      promises.push(changeEmail(emailRef.current.value));
    }
    if (pwdRef.current.value) {
      return promises.push(changePassword(pwdRef.current.value));
    }

    Promise.all(promises)
      .then(() => {
        history.push("/admin");
      })
      .catch(() => {
        setError("Failed to update account");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    adminRecord && setImage(adminRecord.image);
  }, [adminRecord]);

  useEffect(() => {
    const q = query(
      collection(db, "admins"),
      where("email", "==", currentUser?.email)
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      if (querySnapshot.empty) {
        setMessage("No matching admin records");
        setTimeout(() => {
          setMessage("");
        }, 2000);
        setAdminRecord(undefined);
        return;
      }

      const admins = [];
      querySnapshot.forEach((doc) => {
        admins.push({ ...doc.data(), _id: doc.id });
      });
      console.log("admins: ", currentUser, admins);
      setAdminRecord(admins[0]);
    });
    return () => unsubscribe;
  }, [currentUser]);

  const handlePublicSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    console.log(currentUser);
    if (currentUser?.email) {
      let newRec = {
        ...adminRecord,
        name: nameRef.current.value,
        image: image,
        email: currentUser.email,
      };
      if (
        image !== adminRecord?.image ||
        nameRef.current.value !== adminRecord?.name
      ) {
        console.log("adminRecord", adminRecord, newRec);
        try {
          if (newRec._id) await setDoc(doc(db, "admins", newRec._id), newRec);
          else {
            let id = await addDoc(collection(db, "admins"), newRec);
            console.log(id);
            newRec._id = id;
          }
          setAdminRecord(newRec);
          setMessage("Your public profile was uploaded");
          setTimeout(() => setMessage(""), 2000);
        } catch {
          setError("Failed");
        }
      } else {
        // setError("Hmm... you seem to not be there");
      }
      setLoading(false);
    }
  };

  return (
    <>
      <Card className="mt-3">
        <Card.Body>
          <h2 className="text-center mb-4">Update Login Details</h2>
          {currentUser?.email}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                required
                ref={emailRef}
                defaultValue={currentUser.email}
              ></Form.Control>
            </Form.Group>
            <Form.Group id="pwd">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                ref={pwdRef}
                placeholder="Leave blank to keep the same"
              ></Form.Control>
            </Form.Group>
            <Form.Group id="pwd-confirm">
              <Form.Label>Repeat password</Form.Label>
              <Form.Control
                type="password"
                ref={pwdConfirmRef}
                placeholder="Leave blank to keep the same"
              ></Form.Control>
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              Update
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <Card className="mt-3">
        <Card.Body>
          <h2 className="text-center mb-4">Update Public Image</h2>
          {currentUser?.email}
          {message && <Alert variant="info">{message}</Alert>}
          <Form onSubmit={handlePublicSubmit}>
            <Form.Group id="email">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="string"
                required
                ref={nameRef}
                defaultValue={adminRecord?.name ? adminRecord.name : ""}
              ></Form.Control>
            </Form.Group>
            <Image thumbnail src={image}></Image>
            <input
              style={{
                display: "none",
              }}
              ref={inputImage}
              accept="image/*"
              id="icon-button-file"
              type="file"
              capture="environment"
              onChange={onImageSelect}
            />
            <Button
              className="w-100 mt-3"
              onClick={() => inputImage.current.click()}
            >
              Take Selfie
            </Button>
            <Button disabled={loading} className="w-100 mt-3" type="submit">
              Update
            </Button>
          </Form>
        </Card.Body>
      </Card>

      <div className="w-100 text-center mt-2">
        <Link to="/admin">Cancel</Link>
      </div>
    </>
  );
};

export default UpdateProfile;
